import PresenceList from '@/api/resources/presence_lists';

const state = {
  presenceLists: [],
  listStudent: [],
  listStudentAbsence: [],
  className: '',
};

const getters = {
  getPresenceLists: () => (state.presenceLists),
  getListStudent: () => (state.listStudent),
  getListStudentAbsence: () => (state.listStudentAbsence),
  getClassName: () => (state.className),
};

const actions = {
  fetchPresenceLists({ commit, dispatch }) {
    dispatch('initLoading');
    PresenceList.index().then((response) => {
      commit('setPresenceLists', response);
      dispatch('removeLoading');
    });
  },
  fetchStudentsByClass({ commit, dispatch }, params) {
    dispatch('initLoading');
    PresenceList.show(params).then((response) => {
      commit('setListStudent', response);
      dispatch('removeLoading');
    });
  },
  fetchStudentAbsense({ commit, dispatch }, params) {
    dispatch('initLoading');
    PresenceList.listAbsenceByStudent(params).then((response) => {
      commit('setListStudentAbsence', response);
      dispatch('removeLoading');
    });
  },
  setClassName({ commit, dispatch }, params) {
    commit('setClassName', params);
    dispatch('removeLoading');
  },
  clearListStudent({ commit, dispatch }) {
    commit('setListStudent', []);
    commit('setListStudentAbsence', []);
    dispatch('removeLoading');
  },
};

const mutations = {
  setPresenceLists($state, payload) {
    const stateCopy = $state;
    stateCopy.presenceLists = payload;
  },
  setListStudent($state, payload) {
    const stateCopy = $state;
    stateCopy.listStudent = payload;
  },
  setListStudentAbsence($state, payload) {
    const stateCopy = $state;
    stateCopy.listStudentAbsence = payload;
  },
  setClassName($state, payload) {
    const stateCopy = $state;
    stateCopy.className = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
